import React from 'react'
import * as PropTypes from 'prop-types'
import 'rmc-picker/assets/index.css'
import 'rmc-date-picker/assets/index.css'
import 'rmc-picker/assets/popup.css'
// import zh_CN from 'rmc-date-picker/lib/locale/zh_CN'
import RCDatePicker from 'rmc-date-picker/lib/DatePicker'
import PopPicker from 'rmc-date-picker/lib/Popup'
import { DatePickerPropsType } from './PropsType'
import { formatFn, getComponentLocale } from './utils'

export interface PropsType extends DatePickerPropsType {
    prefixCls?: string
    pickerPrefixCls?: string
    className?: string
    use12Hours?: boolean
    popupPrefixCls?: string
    onOk?: (x: any) => void
    onVisibleChange?: (visible: boolean) => void
}

class DatePicker extends React.Component<PropsType, any> {
    static defaultProps = {
        mode: 'datetime',
        // prefixCls: 'am-picker',
        // pickerPrefixCls: 'am-picker-col',
        // popupPrefixCls: 'am-picker-popup',
        minuteStep: 1,
        use12Hours: false,
    }

    static contextTypes = {
        antLocale: PropTypes.object,
    }

    private scrollValue: any

    format = (date) => {
        let mday = date.getDate()
        let month = date.getMonth() + 1
        month = month < 10 ? `0${month}` : month
        mday = mday < 10 ? `0${mday}` : mday
        return `${date.getFullYear()}-${month}-${mday} ${date.getHours()}:${date.getMinutes()}`
    }

    setScrollValue = (value: any) => {
        this.scrollValue = value
    }

    onVisibleChange = (visible: boolean) => {
        this.scrollValue = undefined
        if (this.props.onVisibleChange) {
            this.props.onVisibleChange(visible)
        }
    }

    onOk = (value: any) => {
        if (this.scrollValue !== undefined) {
            value = this.scrollValue
        }
        if (this.props.onChange) {
            this.props.onChange(value)
        }
        if (this.props.onOk) {
            this.props.onOk(value)
        }
    }

    fixOnOk = (picker: any) => {
        if (picker) {
            picker.onOk = this.onOk
        }
    }

    render() {
        const { props, context } = this
        const { children, value, popupPrefixCls } = this.props
        const locale = getComponentLocale(props, context, 'DatePicker', () =>
            require('./locale/zh_CN')
        )
        const { okText, dismissText, extra, DatePickerLocale } = locale
        const datePicker = (
            <RCDatePicker
                minuteStep={this.props.minuteStep}
                locale={DatePickerLocale}
                minDate={this.props.minDate}
                maxDate={this.props.maxDate}
                mode={this.props.mode}
                pickerPrefixCls={this.props.pickerPrefixCls}
                prefixCls={this.props.prefixCls}
                defaultDate={value || new Date()}
                use12Hours={this.props.use12Hours}
                onValueChange={this.props.onValueChange}
                onScrollChange={this.setScrollValue}
            />
        )
        return (
            <PopPicker
                datePicker={datePicker}
                WrapComponent='div'
                transitionName='rmc-picker-popup-slide-fade'
                maskTransitionName='rmc-picker-popup-fade'
                {...(this.props as any)}
                prefixCls={popupPrefixCls}
                date={value || new Date()}
                dismissText={this.props.dismissText || dismissText}
                okText={this.props.okText || okText}
                ref={this.fixOnOk}
                onVisibleChange={this.onVisibleChange}
            >
                {children &&
                    React.isValidElement(children) &&
                    React.cloneElement<{ extra?: string }>(children, {
                        extra: value
                            ? formatFn(this, value)
                            : this.props.extra || extra,
                    })}
            </PopPicker>
        )
    }
}

export default DatePicker
